import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdMessage } from "react-icons/md"; // Assuming you want to use a message icon
import './NotificationButton.scss';

const NotificationButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/Milieu');
  };

  return (
    <div className="notification-button" onClick={handleClick}>
      <div className="icon-wrapper">
        <MdMessage className="icon" />
      </div>
      <div className="text-wrapper">
        <span className="notification-text">
        Please confirm that my payment information is correct before payment, and remember to click after the transfer is completed!
        </span>
        <span className="notification-time">17:09</span>
      </div>
    </div>
  );
};

export default NotificationButton;
